import i18n from '../../i18n.js';

//made it function so changing language will reflect - constant vs function
export const PROCTOR_PAUSE_DIALOG = () => {
  return {
    header: i18n.t('components.learnosityDialogs.assessmentPausedTitle'),
    body: i18n.t('components.learnosityDialogs.pausedByAdmin'),
    buttons: [],
  };
};

export const PROCTOR_SAVE_DIALOG = (buttons) => {
  return {
    header: i18n.t(
      'components.learnosityDialogs.assessmentSavedAndExitingTitle',
    ),
    body: i18n.t(
      'components.learnosityDialogs.assessmentSavedAndExitingMessage',
    ),
    buttons: buttons ? buttons : [],
  };
};

export const PROCTOR_SUBMIT_DIALOG = (buttons) => {
  return {
    header: i18n.t(
      'components.learnosityDialogs.assessmentSubmittedAndExitingTitle',
    ),
    body: i18n.t(
      'components.learnosityDialogs.assessmentSubmittedAndExitingMessage',
    ),
    buttons: buttons ? buttons : [],
  };
};

export const PROCTOR_TERMINATE_DIALOG = (buttons) => {
  return {
    header: i18n.t(
      'components.learnosityDialogs.assessmentTerminatedAndExitingTitle',
    ),
    body: i18n.t(
      'components.learnosityDialogs.assessmentTerminatedAndExitingMessage',
    ),
    buttons: buttons ? buttons : [],
  };
};

export const TESTER_SAVE_DIALOG = (buttons) => {
  return {
    header: i18n.t(
      'components.learnosityDialogs.assessmentSavedAndExitingTitle',
    ),
    body: i18n.t(
      'components.learnosityDialogs.assessmentSavedCountdownMessage',
    ),
    buttons: buttons ? buttons : [],
  };
};

export const IDLE_DIALOG = (buttons) => {
  return {
    header: i18n.t('components.learnosityDialogs.idleTimeoutTitle'),
    body: i18n.t('components.learnosityDialogs.idleTimeoutMessage'),
    buttons: buttons ? buttons : [],
  };
};

export const LAUNCH_ERROR_DIALOG = (buttons) => {
  return {
    header: i18n.t('components.learnosityDialogs.launchErrorTitle'),
    body: i18n.t('components.learnosityDialogs.launchErrorProctorNotified'),
    buttons: buttons ? buttons : [],
  };
};

export const PREVIEW_LAUNCH_ERROR_DIALOG = (buttons) => {
  return {
    header: i18n.t('components.learnosityDialogs.launchErrorTitle'),
    body: i18n.t('components.learnosityDialogs.launchErrorClosing'),
    buttons: buttons ? buttons : [],
  };
};

export const DUPLICATE_LOGIN_ERROR_DIALOG = (buttons) => {
  return {
    header: i18n.t('components.learnosityDialogs.multipleLoginsTitle'),
    body: i18n.t('components.learnosityDialogs.multipleLoginsMessage'),
    buttons: buttons ? buttons : [],
  };
};

export const ABORT_LOGIN_ERROR_DIALOG = (buttons) => {
  return {
    header: i18n.t('components.learnosityDialogs.serviceErrorTitle'),
    body: i18n.t('components.learnosityDialogs.serviceErrorMessage'),
    buttons: buttons ? buttons : [],
  };
};

export const NETWORKORSAVE_ERROR_DIALOG = (buttons) => {
  return {
    header: i18n.t('components.learnosityDialogs.serviceErrorTitle'),
    body: i18n.t('components.learnosityDialogs.lostConnectivityMessage'),
    buttons: buttons ? buttons : [],
  };
};

export const PAUSED_DUE_TO_ACTION = (action, buttons) => {
  return {
    header: i18n.t('components.lessThanSecure.prohibitedActionPausedTitle'),
    body:
      i18n.t('components.lessThanSecure.prohibitedActionPrefix') +
      (action ? `: ${action}` : ''),
    buttons: buttons ? buttons : [],
  };
};
